<template>
	<div class="actions-screen flex flex-center column text-black">
		<div class="col-width text-center">
			<!--
			<h2 class="text-h3">
				Comme nos activistes, passez à l'action&nbsp;!
			</h2>
			-->
			<p>
				Nous vous proposons d'agir directement auprès du gouvernement. C'est à cause de son laxisme que la France importe encore du soja et d'autres matières premières ayant contribué à la déforestation. Il faut que ça cesse.
			</p>


			<p>
				<b>Une fois que vous avez agi, cliquez sur le bouton "Je confirme avoir agi"</b>.
			</p>

		</div>

		<div class="q-my-lg actions-width row wrap justify-between items-stretch">

			<action-btn class="col-xs-6 action-button" v-model="tab" name="mail-gouvernement" label="Interpellez le gouvernement par email"/>
			<action-btn class="col-xs-6 action-button" v-model="tab" name="rs" label="Agissez sur les réseaux sociaux"/>

		</div>

		<div class="col-width" ref="actions">

			<q-tab-panels
				v-model="tab"
				>

				<q-tab-panel name="mail-gouvernement">
					<h3>
						<q-icon class="icon-fleche"/>
						Interpellez le gouvernement par email
					</h3>
					<p>
						Les adresses mail à contacter sont&nbsp;: <a href="mailto:secretariat.ministre@ecologique-solidaire.gouv.fr">secretariat.ministre@ecologique-solidaire.gouv.fr</a> et <a href="mailto:sp.ministre@agriculture.gouv.fr">sp.ministre@agriculture.gouv.fr</a>
					</p>

					<p>
						Vous pouvez envoyer <a :href="mailto">ce mail pré-rédigé</a>, ou bien en rédiger un vous-même. 
					</p>

					<p>
						<b>Voici un peu d'inspiration pour vous guider&nbsp;:</b>
					</p>

					<div class="script">
						<p>
							Bonjour,
						</p>
						<p>
En Amérique du Sud, les forêts brûlent. Malgré plusieurs appels citoyens au cours des dernières semaines, vous faites la sourde oreille et n'entreprenez pas d'action réellement à même de mettre fin à la "complicité" avouée par Emmanuel Macron de la France dans ce désastre. La preuve&nbsp;: un nouveau cargo de soja arrive ce jeudi dans un port près de Saint Nazaire pour déverser 60 000 tonnes de soja en provenance du Cerrado, un écosystème ravagé par la culture du soja&nbsp;!
						</p>
						<p>
Il est urgent d'en finir avec l’agriculture industrielle qui détruit les forêts et d'autres écosystèmes précieux pour y élever du bétail et cultiver du soja qui alimente nos fermes-usines. Nos demandes sont simples&nbsp;: 
						</p>
						<p>
 1. Elisabeth Borne doit faire appliquer la Stratégie Nationale de lutte contre la Déforestation (SNDI) en arrêtant toute importation sur notre territoire de matières premières ayant contribué à la déforestation.
						</p>
						<p>
 2. Didier Guillaume doit également inscrire cet objectif de stopper toute importation de produits ayant contribué à la déforestation dans le Plan Protéines Végétales qu'il doit prochainement adopter.
						</p>
						<p>
 3. Enfin, nos deux ministres doivent engager la transition écologique de notre élevage, en particulier à travers la future Politique Agricole Commune (PAC).
Le temps presse.
						</p>
						<p>
Merci,
<br/>
Cordialement,
						</p>



					</div>

					<p>
						<q-btn class="btn-main q-mt-lg" label="Je confirme avoir agi" @click="submitAction()"/>
					</p>
				</q-tab-panel>

				<q-tab-panel name="rs">
					<h3>
						<q-icon class="icon-fleche"/>
						Agissez sur les réseaux sociaux
					</h3>

					<p>
						Affichez la complicité de notre gouvernement sur votre réseau social préféré. 
					</p>

					<ul>
						<li>
							Sur Facebook, <u @click="shareFacebook">partagez cette page</u>.
						</li>
						<li>
							Sur Twitter, <u @click="shareTwitter">partagez ce tweet</u>. Très important&nbsp;: personnalisez-le, ça lui donnera encore plus de visibilité&nbsp;!
						</li>
						<li>
							Sur Whatsapp, <u @click="shareWhatsapp">partagez ce message</u> à vos proches. Plus vous parviendrez à mobiliser autour de vous, plus notre action aura des chances d'aboutir&nbsp;!
						</li>
					</ul>

					<p>
						Voici un exemple de post à partager sur vos réseaux dans lequel vous pouvez taguer Elisabeth Borne, ministre de la Transition écologique et solidaire, et Didier Guillaume, ministre de l'Agriculture&nbsp;:
					</p>

					<p>
						<em>
							Un nouveau cargo chargé de 60000&nbsp;t de soja venant d'une zone déforestée arrive en France pour alimenter l'élevage industriel. @Elisabeth_Borne, @dguillaume26, la France est complice de la déforestation. Ça suffit&nbsp;! #LaFranceComplice #AlerteDeforestation https://www.greenpeace.fr/preuve-deforestation
						</em>

					</p>

					<p>
						<q-btn class="btn-main q-mt-lg" label="Je confirme avoir agi" @click="submitAction()"/>
					</p>
				</q-tab-panel>



			</q-tab-panels>


			<share-items class="share-page" v-if="tab !== ''"/>


		</div>
	</div>
</template>

<script>
import ActionBtn from './ActionBtn.vue'
import ShareItems from './ShareItems.vue'


export default {
	name: "ActionsScreen",
	components: {
		ActionBtn,
		ShareItems,
	},
	methods: {

		shareWhatsapp() {
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "partage whatsapp",
			})


			window.open("", 'share')
		},
		shareInstagram() {
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "partage instagram",
			})



			//window.open(this.lienArticle, '_blank')

		},
		shareTwitter() {
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "partage twitter",
			})


			window.open('' , 'share')

		},
		shareFacebook() {
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "partage facebook",
			})


			window.open('' , 'share')
		},
		submitAction() {
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "validation action",
			})
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "validation action " + this.tab,
			})


			this.$emit('action', this.tab)
		}
	},
	computed: {
		url() {
			return location.protocol + "//" + location.hostname + location.pathname
		},
		lienAffiche() {
			return ""
		},

	},
	data() {
		return {
			mailto: "mailto:secretariat.ministre@ecologique-solidaire.gouv.fr,sp.ministre@agriculture.gouv.fr?bcc=amazoniebrule@greenpeace.fr&body=Bonjour,%0A%0AEn%20Am%C3%A9rique%20du%20Sud,%20les%20for%C3%AAts%20br%C3%BBlent.%20Malgr%C3%A9%20plusieurs%20appels%20citoyens%20au%20cours%20des%20derni%C3%A8res%20semaines,%20vous%20faites%20la%20sourde%20oreille%20et%20n'entreprenez%20pas%20d'action%20r%C3%A9ellement%20%C3%A0%20m%C3%AAme%20de%20mettre%20fin%20%C3%A0%20la%20%22complicit%C3%A9%22%20avou%C3%A9e%20par%20Emmanuel%20Macron%20de%20la%20France%20dans%20ce%20d%C3%A9sastre.%20La%20preuve%20%3A%20un%20nouveau%20cargo%20de%20soja%20arrive%20ce%20jeudi%20dans%20un%20port%20pr%C3%A8s%20de%20Saint%20Nazaire%20pour%20d%C3%A9verser%2060%20000%20tonnes%20de%20soja%20en%20provenance%20du%20Cerrado,%20un%20%C3%A9cosyst%C3%A8me%20ravag%C3%A9%20par%20la%20culture%20du%20soja%20!%0AIl%20est%20urgent%20d'en%20finir%20avec%20l%E2%80%99agriculture%20industrielle%20qui%20d%C3%A9truit%20les%20for%C3%AAts%20et%20d'autres%20%C3%A9cosyst%C3%A8mes%20pr%C3%A9cieux%20pour%20y%20%C3%A9lever%20du%20b%C3%A9tail%20et%20cultiver%20du%20soja%20qui%20alimente%20nos%20fermes-usines.%20Nos%20demandes%20sont%20simples%20%3A%C2%A0%0A%C2%A01.%20Elisabeth%20Borne%20doit%20faire%20appliquer%20la%20Strat%C3%A9gie%20Nationale%20de%20lutte%20contre%20la%20D%C3%A9forestation%20(SNDI)%20en%20arr%C3%AAtant%20toute%20importation%20sur%20notre%20territoire%20de%20mati%C3%A8res%20premi%C3%A8res%20ayant%20contribu%C3%A9%20%C3%A0%20la%20d%C3%A9forestation.%0A%C2%A02.%20Didier%20Guillaume%20doit%20%C3%A9galement%20inscrire%20cet%20objectif%20de%20stopper%20toute%20importation%20de%20produits%20ayant%20contribu%C3%A9%20%C3%A0%20la%20d%C3%A9forestation%20dans%20le%20Plan%20Prot%C3%A9ines%20V%C3%A9g%C3%A9tales%20qu'il%20doit%20prochainement%20adopter.%0A%C2%A03.%20Enfin,%20nos%20deux%20ministres%20doivent%20engager%20la%20transition%20%C3%A9cologique%20de%20notre%20%C3%A9levage,%20en%20particulier%20%C3%A0%20travers%20la%20future%20Politique%20Agricole%20Commune%20(PAC).%0A%0ALe%20temps%20presse.%0A%0AMerci,%0ACordialement,",

			tab: "",
		}
	},

	watch: {
		tab(n) {
			this.$gtm.trackEvent({
				event: "standard",
				category: "kerguelen",
				action: "click",
				label: "choix action " + n,
			})
			this.$emit('select', this.$refs.actions)
			return n
		}
	}

}
</script>

<style lang="stylus" scoped>

.actions-screen
	min-height 100vh
	padding 5rem 1rem
	background-color #fff
	//background-image url(/preuve-deforestation/fond.jpg)
	//background-size cover

.script
	font-style italic

.tel
	span
		text-wrap nowrap

.share-page
	margin-top 5rem
</style>